import React, { useState } from 'react';
import { closestCenter, DndContext } from '@dnd-kit/core';
import { SortableContext, useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
export default function NestedDragDropList({ items, onChange }) {
    const [list, setList] = useState(items);
    const handleDragEnd = (event) => {
        const { active, over } = event;
        if (!over || active.id === over.id)
            return;
        const findItem = (id, list) => {
            for (const item of list) {
                if (item.id === id)
                    return { item, parent: list };
                if (item.children) {
                    const found = findItem(id, item.children);
                    if (found)
                        return found;
                }
            }
            return null;
        };
        const activeItemData = findItem(active.id, list);
        const overItemData = findItem(over.id, list);
        if (!activeItemData || !overItemData)
            return;
        // Remove from old parent
        activeItemData.parent.splice(activeItemData.parent.indexOf(activeItemData.item), 1);
        // Add to new parent (if moving into another item's children)
        if (overItemData.item.children) {
            overItemData.item.children.push(activeItemData.item);
        }
        else {
            // Move in the same level
            const overIndex = overItemData.parent.indexOf(overItemData.item);
            overItemData.parent.splice(overIndex, 0, activeItemData.item);
        }
        setList([...list]);
        onChange([...list]);
    };
    return (React.createElement(DndContext, { collisionDetection: closestCenter, onDragEnd: handleDragEnd },
        React.createElement(SortableContext, { items: list.map((item) => item.id) },
            React.createElement("ul", { style: { listStyle: 'none', padding: 0 } }, list.map((item) => (React.createElement(SortableItem, { key: item.id, item: item })))))));
}
function SortableItem({ item }) {
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: item.id });
    return (React.createElement("li", Object.assign({ ref: setNodeRef }, attributes, listeners, { style: {
            padding: '2px 10px',
            marginBottom: '5px',
            background: 'white',
            border: '1px solid #ddd',
            cursor: 'grab',
            transform: CSS.Transform.toString(transform),
            transition,
        } }),
        item.content,
        item.children && (React.createElement("ul", { style: { marginLeft: '5px', paddingLeft: '10px', borderLeft: '2px solid #ddd' } }, item.children.map((child) => (React.createElement(SortableItem, { key: child.id, item: child })))))));
}
//# sourceMappingURL=NestedDragDropList.js.map